import React, { useState } from 'react'
import ConfirmButton from '../../Components/Buttons/ConfirmButton'
import CancelButton from '../../Components/Buttons/CancelButton'
import Modal from '../../Components/Modal/Modal'
import './CanDeliver.css'

import './model_style.css'

import { createUserObject } from '../Profile/profile.utils'
import FilterAccordion from '../../Components/SearchTeacherFilter/CollapseFilter2'

function RoomOrProgramPopup(props) {
  const is_elt = props.user.is_elt === undefined || props.user.is_elt
  const is_vet = props.user.is_vet

  const { qualifications, selectedData, selectedByQualificationObj, selectedRoomsPrograms } = props

  let userObject = createUserObject(props.user, true)
  const [user_can_deliver, setcan_deliver] = useState({ ...userObject })
  const [is_checked, set_is_checked] = useState(is_elt ? 'ge' : 'bsb')
  const [levels, setVETLevel] = useState([])
  const [selectedList, setSelectedList] = useState(selectedRoomsPrograms || [])
  const [selectedByQualification, setSelectedByQualification] = useState(selectedByQualificationObj)

  const handleLevelChange = (e, qua, rootID) => {
    console.log(`⚡️[log]: †††††† ~ e, qua, rootID: `, e, qua, rootID);
    let currentList = selectedList
    let selectedByQualificationNew = {
      ...selectedByQualification
    }

		if (e.target.checked) {
      currentList.push(e.target.value)
      if(e.target.value !== rootID) {
        currentList = currentList.filter(lv => lv !== rootID);
        if(qua?._id) {
          if(selectedByQualificationNew[qua._id]) {
            selectedByQualificationNew[qua._id] = [
              ...selectedByQualificationNew[qua._id],
              e.target.value
            ]?.filter(ele => ele !== rootID)
          }
          else {
            selectedByQualificationNew[qua._id] = [e.target.value]
          }
        }
      }
      else {
        if(qua?._id) {
          if(selectedByQualificationNew?.[qua._id]) {
            currentList = currentList.filter(lv => !selectedByQualificationNew?.[qua._id]?.includes(lv))
          }
          selectedByQualificationNew[qua._id] = [e.target.value]
        }
      }
      setSelectedList(currentList)
		} else {
      currentList = currentList.filter(lv => lv !== e.target.value);
      if(qua?._id && selectedByQualificationNew?.[qua._id]) {
        selectedByQualificationNew[qua._id] = selectedByQualificationNew[qua._id].filter(lv => lv !== e.target.value)
      }
      setSelectedList(currentList) 
		}
    setSelectedByQualification(selectedByQualificationNew)
	}

  return (
    <>
      <Modal
        show={props.show}
        onClose={props.onClose}
        className='model-for-addform custom-for-addCanDeliver'
        header="Add/Remove Rooms/Programs"
      >
        {/* <div className="mb-2">
          <em>Can't find a course you are qualified to deliver? Email us at <a href="mailto:helpdesk@readyteacher.com.au">helpdesk@readyteacher.com.au</a> to add it here</em>
        </div> */}
        <div className='main-content-select'>
          {qualifications?.length && <FilterAccordion 
            qualificationList={qualifications}
            levels={levels}
            selectedList={selectedList}
            onChangeCategory={(e, qua, rootID) => handleLevelChange(e, qua, rootID)}
            showTwoColumns
            includeTeacherCategory
            isChildcareCentre={true}
          />}
        </div>

        <div className='row qualification-footer mt-5'>
          <div className='col-md-6 buttons'>
            <CancelButton onClick={props.onClose}>Cancel</CancelButton>
          </div>
          <div className='col-md-6 buttons'>
            <ConfirmButton
              onClick={() => {
                props.onSubmit(selectedList)
              }}
            >
              Submit
            </ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default RoomOrProgramPopup
